import * as types from '../mutations'

const services = {
  member: window.abp.services.app.member,
  invoice: window.abp.services.app.invoice
}

const state = {
  // search
  all: [],
  pagination: {},
  activeMember: {},
  groupSearch: {},
  searchOperations: [],
  dataFields: [],
  savedSearchCriterias: [],

  // audit logs
  auditLogs: [],
  auditLogsPagination: {},

  // invoices
  invoices: [],
  activeInvoice: {},

  // subscriptions
  paymentOptions: []
}

const getters = {
  // search
  allMembers: state => state.all,
  allMembersPagination: state => state.pagination,
  activeMember: state => state.activeMember,
  groupSearch: state => state.groupSearch,
  searchOperations: state => state.searchOperations,
  dataFields: state => state.dataFields,
  savedSearchCriterias: state => state.savedSearchCriterias,

  // audit logs
  auditLogs: state => state.auditLogs,
  auditLogsPagination: state => state.auditLogsPagination,

  // invoices
  memberInvoices: state => state.invoices,
  memberPaymentOptions: state => state.paymentOptions,
  activeInvoice: state => state.activeInvoice
}

// actions
const actions = {
  getAllMembers({ commit }, request) {
    return new Promise((resolve, reject) => {
      if (request) {
        services.member.search(request).done(function (response) {
          let members = response.items
          let pagination = {
            currentPage: response.currentPage,
            totalCount: response.totalCount,
            totalPage: response.totalPage
          }
          commit(types.DATA.RECEIVE_MEMBERS, { members, pagination })
          resolve()
        })
      } else {
        let members = []
        let pagination = {}
        commit(types.DATA.RECEIVE_MEMBERS, { members, pagination })
        resolve()
      }
    })
  },
  getMember({ commit }, id) {
    let request = { id: id }
    return new Promise((resolve, reject) => {
      services.member.get(request).done(function (response) {
        commit(types.DATA.UPDATE_ACTIVE_MEMBER, response)
        resolve()
      })
    })
  },
  getMemberAuditLogs({ commit }, id) {
    let request = { id: id }
    return new Promise((resolve, reject) => {
      services.member.getAuditLog(request).done(function (response) {
        let auditLogs = response.items
        let pagination = {
          currentPage: response.currentPage,
          totalCount: response.totalCount,
          totalPage: response.totalPage
        }
        commit(types.DATA.RECEIVE_MEMBER_AUDIT_LOGS, { auditLogs, pagination })
        resolve()
      })
    })
  },
  getSearchOperations({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.member.getSearchOperations(request).done(function (response) {
        commit(types.DATA.RECEIVE_SEARCH_OPERATIONS, response)
        resolve()
      })
    })
  },
  getInternalDataFields({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.member.getInternalDataFields(request).done(function (response) {
        commit(types.DATA.RECEIVE_INTERNAL_DATA_FIELDS, response)
        resolve()
      })
    })
  },
  getHistory({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.member.getHistory({ id }).done(function (response) {
        commit(types.DATA.RECEIVE_HISTORY, response)
        resolve()
      })
    })
  },
  setGroupForSearch({ commit }, group) {
    commit(types.DATA.SET_GROUP_FOR_SEARCH, group)
  },
  setMemberGroups({ commit }, request) {
    return new Promise((resolve, reject) => {
      services.member.updateGroup(request).done(function (response) {
        commit(types.DATA.UPDATE_ACTIVE_MEMBER, response)
        resolve()
      })
    })
  },
  createMember({ commit }, { groupId, email }) {
    return new Promise((resolve, reject) => {
      console.log(groupId)
      services.member.createFromGroup({ groupId, email })
        .done(function (response) {
          resolve(response.id)
        })
    })
  },
  getInvoice({ commit }, id) {
    let request = { id: id }
    return new Promise((resolve, reject) => {
      services.invoice.get(request).done(function (response) {
        commit(types.DATA.UPDATE_ACTIVE_INVOICE, response)
        resolve()
      })
    })
  },
  createInvoice({ dispatch, commit }, { memberId, paymentOptionId }) {
    return new Promise((resolve, reject) => {
      services.invoice.createAsync({ memberId, paymentOptionId })
        .done(function (response) {
          commit(types.DATA.RECEIVE_HISTORY, response)
          dispatch('getHistory', memberId).then(() => resolve())
        })
    })
  },
  deleteInvoice({ dispatch, commit }, request) {
    return new Promise((resolve, reject) => {
      services.invoice.delete(request)
        .done(function (response) {
          dispatch('getHistory', request.memberId).then(() => resolve())
        })
    })
  },
  changeInvoiceStatus({ dispatch, commit }, request) {
    return new Promise((resolve, reject) => {
      services.invoice.changeStatus(request)
        .done(function (response) {
          dispatch('getHistory', request.memberId).then(() => resolve())
        })
    })
  },
  assignSubscription({ commit }, { memberId, paymentOptionId }) {
    return new Promise((resolve, reject) => {
      services.member.assignSubscription({ memberId, paymentOptionId })
        .done(function (response) {
          commit(types.DATA.RECEIVE_HISTORY, response)
          resolve()
        })
    })
  },
  cancelSubscription({ commit }, { memberId, paymentOptionId }) {
    return new Promise((resolve, reject) => {
      services.member.cancelSubscription({ memberId, paymentOptionId })
        .done(function (response) {
          commit(types.DATA.RECEIVE_HISTORY, response)
          resolve()
        })
    })
  },
  deleteMember({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.member.delete({ id: id })
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_GROUP, null)
          resolve()
        })
    })
  },
  removeCharge({ dispatch, commit }, request) {
    return new Promise((resolve, reject) => {
      services.invoice.removeCharge(request)
        .done(function (response) {
          resolve()
        })
    })
  },
  saveCharge({ dispatch, commit }, request) {
    return new Promise((resolve, reject) => {
      services.invoice.saveCharge(request)
        .done(function (response) {
          resolve()
        })
    })
  },
  getSavedSearchCriterias({ commit }) {
    return new Promise((resolve, reject) => {
      let request = {
        page: 1,
        maxResultCount: 100
      }
      services.member.getSavedSearchCriterias(request).done(function (response) {
        let savedSearchCriterias = response.items
        commit(types.DATA.RECEIVE_SAVED_SEARCH_CRITERIAS, savedSearchCriterias)
        resolve()
      })
    })
  },
  createSavedSearchCriterias({ dispatch, commit }, request) {
    return new Promise((resolve, reject) => {
      services.member.createSavedSearchCriterias(request)
        .done(function (response) {
          resolve()
        })
    })
  }
}

// mutations
const mutations = {
  [types.DATA.RECEIVE_MEMBERS](state, { members, pagination }) {
    state.all = members
    state.pagination = pagination
  },
  [types.DATA.RECEIVE_MEMBER_AUDIT_LOGS](state, { auditLogs, pagination }) {
    state.auditLogs = auditLogs
    state.auditLogsPagination = pagination
  },
  [types.DATA.UPDATE_ACTIVE_MEMBER](state, member) {
    state.activeMember = member
  },
  [types.DATA.SET_GROUP_FOR_SEARCH](state, group) {
    state.groupSearch = group
  },
  [types.DATA.RECEIVE_SEARCH_OPERATIONS](state, operations) {
    state.searchOperations = operations
  },
  [types.DATA.RECEIVE_INTERNAL_DATA_FIELDS](state, fields) {
    state.dataFields = fields
  },
  [types.DATA.RECEIVE_HISTORY](state, history) {
    state.invoices = history.invoices
    state.paymentOptions = history.paymentOptions
  },
  [types.DATA.UPDATE_ACTIVE_INVOICE](state, invoice) {
    state.activeInvoice = invoice
  },
  [types.DATA.RECEIVE_SAVED_SEARCH_CRITERIAS](state, savedSearchCriterias) {
    state.savedSearchCriterias = savedSearchCriterias
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./scripts/store/modules/members.js